//  Node imports
import { Bitmap, delayedCall, dispatcher, Graphics, IEvent, ingenuity, killDelayedCall, SpineBase } from "@quest/base-core";
import { FreeGameController, MeterBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { View } from "./View";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { ITween } from "@quest/adapter-interface";
import { Linear } from "@quest/pixi-bridge";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

//  Class impotrs
export class FreeGameControllerGame extends FreeGameController {
  protected view: View;
  private fgReelBgAnim: SpineBase;
  private NoteBackMeterText: MeterBehavior;
  private MagnifyMeterText: MeterBehavior;
  private KeyMeterText: MeterBehavior;
  private BoardProgressMeterText: MeterBehavior;
  private BoardProgress: Bitmap;
  private BoardProgressHighlight: Bitmap;
  private progressMask: Graphics;
  private currentLevelProgress: number = 0
  private category: any = {
    "symbol51": "NoteBack",
    "symbol52": "Magnify",
    "symbol53": "Key"
  };

  protected initializeComponents(): void {
    super.initializeComponents();
    this.view.mask = this.view.getShapeById("reelMaskFg");
    this.fgReelBgAnim = this.view.getSpineById("freeGameReelGlow");
    this.NoteBackMeterText = this.view.getMeterById('NoteBackMeterText') as MeterBehavior;
    this.MagnifyMeterText = this.view.getMeterById('MagnifyMeterText') as MeterBehavior;
    this.KeyMeterText = this.view.getMeterById('KeyMeterText') as MeterBehavior;
    this.BoardProgressMeterText = this.view.getMeterById('BoardProgressMeterText') as MeterBehavior;
    this.BoardProgress = this.view.getImageById('BoardProgress');
    this.progressMask = this.view.getShapeById("progressBarMask")
    this.BoardProgress.mask = this.progressMask
    this.BoardProgressHighlight = this.view.getImageById('BoardProgressHighlight')

  }

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_METER_VALUES_FG, this.updateMeterValues, this)
    dispatcher.on(eventDispatchers.PLAY_BLAST_ON_WIN_METER_FG, this.playBlastAnimOnWinMeter, this);
    dispatcher.on(eventDispatchers.PLAY_REVEALED_CLUE_ANIMATION_FG, this.startBorderAnim, this)
    dispatcher.on(eventDispatchers.ALIGN_PROGRESS_BAR_FG, this.alignProgressBar, this)
    dispatcher.on(eventDispatchers.HIDE_FREEGAME_REEL, this.hideReelView, this);
    dispatcher.on(eventDispatchers.SHOW_FREEGAME_REEL, this.showReelView, this);
            dispatcher.on(eventDispatchers.HANDLE_BUTTON_AS_PER_MARKET, this.handleOnDifferentMarket, this);


  }
  protected unsubscribeEventsFG(): void {
    super.unsubscribeEventsFG();
    dispatcher.off(eventDispatchers.UPDATE_METER_VALUES_FG, this.updateMeterValues, this)
    dispatcher.off(eventDispatchers.PLAY_BLAST_ON_WIN_METER_FG, this.playBlastAnimOnWinMeter, this);
    dispatcher.off(eventDispatchers.PLAY_REVEALED_CLUE_ANIMATION_FG, this.startBorderAnim, this)
    dispatcher.off(eventDispatchers.ALIGN_PROGRESS_BAR_FG, this.alignProgressBar, this)
    dispatcher.off(eventDispatchers.HIDE_FREEGAME_REEL, this.hideReelView, this);
    dispatcher.off(eventDispatchers.SHOW_FREEGAME_REEL, this.showReelView, this);
            dispatcher.off(eventDispatchers.HANDLE_BUTTON_AS_PER_MARKET, this.handleOnDifferentMarket, this);

  }

  // Overrided to play fg bg reel animation
  protected onShowFreeGame(): void {
    this.view.setReelMask();
    super.onShowFreeGame();
    this.playFreeGameReelBgAnim();
    this.progressMeterValues();
    // TODO: code will be used when freegame data will also contain preCollectMeter for broken handeling
    // if ((ingenuity.parserModel as GameParserModel).getPreCollectMeterData() !== undefined && !(ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered()) {
    //   this.progressMeterValues((ingenuity.parserModel as GameParserModel).getPreCollectMeterData());
    // } else {
    //   this.progressMeterValues((ingenuity.parserModel as GameParserModel).getCollectMeterData());
    // }
  }

  protected startspin(): void {
    super.startspin();
    dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER_FG);
  }

  // Add to play free game reel animation
  private playFreeGameReelBgAnim(): void {
    this.fgReelBgAnim.visible = true;
    this.fgReelBgAnim.setPause(false);
    this.fgReelBgAnim.playAnim("freegame_idle_desktop_reel_glow", true);
  }

  private updateMeterValues(evt: IEvent): void {
    let symbol: number = evt.data.symbol;
    let specialSymbol: Bitmap;
    let collect_anim: SpineBase;
    switch (symbol) {
      case 11:
        collect_anim = this.view.getSpineById('collectEffectNote');
        specialSymbol = this.view.getImageById('NoteBack');
        break;
      case 12:
        collect_anim = this.view.getSpineById('collectEffectMagnify');
        specialSymbol = this.view.getImageById('Magnify');

        break;
      case 13:
        collect_anim = this.view.getSpineById('collectEffecKey');
        specialSymbol = this.view.getImageById('Key');
        break;
    }
    this.zoomSpecialSymbol(specialSymbol, symbol);
    this.progressMeterValues();
    collect_anim.visible = true;
    collect_anim.playAnim('collect_effect', true);
    collect_anim.onComplete.addOnce(() => {
      collect_anim.visible = false;
    })
  }

  private zoomSpecialSymbol(symbol: Bitmap, symbolId: number): void {
    let baseZoomInTween: ITween = ingenuity.currentGame.add.tween(symbol.scale).to({ x: 1.2, y: 1.2 }, SlotConstantsBehavior.DURATION_300, Linear.None, true, 0, 0, true);
    baseZoomInTween.onComplete.addOnce(() => {
      baseZoomInTween.stop();
      ingenuity.currentGame.tweens.remove(baseZoomInTween);
    }, this)
  }

  private startBorderAnim(): void {
    let clueRevealed = (ingenuity.parserModel as GameParserModel).getclueRevealedInfo().pickedClue;
    this.zoomInOutClue(this.category[clueRevealed]);
    let clueSpine = this.view.getSpineById(`borderEffect${this.category[clueRevealed]}`);
    let borderSpine = this.view.getSpineById('boardProgressbarBorderEffect');
    let anim: string;
    if (clueRevealed == 'symbol51') {
      anim = 'symbol_effect_red';
    } else if (clueRevealed == 'symbol52') {
      anim = 'symbol_effect_purple';
    } else {
      anim = 'symbol_effect_sky';
    }
    clueSpine.setPause(false);
    clueSpine.visible = true;
    clueSpine.playAnim(anim, true);
    borderSpine.setPause(false);
    borderSpine.visible = true;
    borderSpine.playAnim('metter_effect_win_loop', true);
    delayedCall('startInvestigation', SlotConstantsBehavior.DURATION_2000, () => {
      killDelayedCall('startInvestigation');
      this.stopBorderAnimations(clueSpine, borderSpine)
    })
  }

  private zoomInOutClue(clue: string): void {
    let meter = this.view.getContainerByID(`${clue}TweenContainer`);
    let meterTween = ingenuity.currentGame.add.tween(meter.scale).to({ x: 1.1, y: 1.1 }, SlotConstantsBehavior.DURATION_1000, Linear.None, true, 100, -1, true);
    delayedCall('stopTweens', SlotConstantsBehavior.DURATION_2000, () => {
      killDelayedCall('stopTweens');
      meterTween.stop();
      ingenuity.currentGame.tweens.remove(meterTween);
    })
  }


  private stopBorderAnimations(clueSpine: SpineBase, borderSpine: SpineBase): void {
    borderSpine.setPause(true);
    borderSpine.visible = false;
    clueSpine.setPause(true);
    clueSpine.visible = false;
    dispatcher.fireEvent(eventDispatchers.START_CLUE_REVEAL);
  }


  private progressMeterValues(): void {
    const meterData: any = (ingenuity.parserModel as GameParserModel).getCollectMeterData();
    const limitData: any = (ingenuity.parserModel as GameParserModel).getCollectLimitData();

    if (!meterData) return;
    this.NoteBackMeterText.setValue(meterData.symbol51);
    this.MagnifyMeterText.setValue(meterData.symbol52);
    this.KeyMeterText.setValue(meterData.symbol53);
    const totalSymbolCollected = (meterData.symbol51 > limitData.symbol51 ? limitData.symbol51 : meterData.symbol51) + (meterData.symbol52 > limitData.symbol52 ? limitData.symbol52 : meterData.symbol52) + (meterData.symbol53 > limitData.symbol53 ? limitData.symbol53 : meterData.symbol53);
    this.storeSymbolLimit(meterData, limitData);
    this.handleLimitReached(meterData, limitData);
    const totalLimit = limitData.symbol51 + limitData.symbol52 + limitData.symbol53;
    const totalProgress = totalSymbolCollected / totalLimit;
    let progressPercent = "0";
    if (totalSymbolCollected) {
      progressPercent = (totalProgress * 100).toFixed(2) + '%'
    } else {
      progressPercent = "0%"
    }
    this.BoardProgressMeterText.setText(progressPercent);    
    if (totalProgress === 0) {
      this.BoardProgressHighlight.visible = false;
      this.currentLevelProgress = 0;
      this.view.getContainerByID("progressingUpdateContainer").x = 0;
    }
    else {
      this.BoardProgressHighlight.visible = true;
      const progressTween = ingenuity.currentGame.add.tween(this.view.getContainerByID("progressingUpdateContainer"));
      this.currentLevelProgress = totalProgress * gameConstants.PROGRESS_SHIFT_LIMIT;
      progressTween.to({ x: this.currentLevelProgress }, SlotConstantsBehavior.DURATION_1000, Linear.None, true, 0);
      progressTween.onComplete.addOnce(() => {
        progressTween.stop();
        ingenuity.currentGame.tweens.remove(progressTween);
      });
    }
  }
  private storeSymbolLimit(meterData: any, limitData: any): void {
    if (meterData.symbol51 >= limitData.symbol51) {
      !ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_NOTE] && this.playLimitReachedSound();
      ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_NOTE] = true;
    }
    if (meterData.symbol52 >= limitData.symbol52) {
      !ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_MAGNIFY] && this.playLimitReachedSound();
      ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_MAGNIFY] = true;
    }
    if (meterData.symbol53 >= limitData.symbol53) {
      !ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_KEY] && this.playLimitReachedSound();
      ingenuity.configData.isSymbolLimitReached[gameConstants.SPECIAL_SYMBOL_KEY] = true;
    }
  }
  private playLimitReachedSound(): void {
    ingenuity.configData.currentProgressingFill && (ingenuity.soundManager as any).playSound(SoundConstantGame.SPECIAL_PB_WIN, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
  }
  private handleLimitReached(meterData: any, limitData: any): void {
    if (meterData.symbol51 >= limitData.symbol51) {
      this.view.getImageById("NoteBackCheck").visible = true
      this.NoteBackMeterText.visible = false;
    } else {
      this.view.getImageById("NoteBackCheck").visible = false
      this.NoteBackMeterText.visible = true;
    }

    if (meterData.symbol52 >= limitData.symbol52) {
      this.view.getImageById("MagnifyCheck").visible = true
      this.MagnifyMeterText.visible = false;
    } else {
      this.MagnifyMeterText.visible = true;
      this.view.getImageById("MagnifyCheck").visible = false
    }

    if (meterData.symbol53 >= limitData.symbol53) {
      this.KeyMeterText.visible = false;
      this.view.getImageById("KeyCheck").visible = true
    } else {
      this.KeyMeterText.visible = true;
      this.view.getImageById("KeyCheck").visible = false
    }
  }
  private alignProgressBar(): void {
    this.view.getContainerByID("progressingUpdateContainer").x = this.currentLevelProgress;
  }

  protected onHideFreeGame(): void {
    super.onHideFreeGame();
    // dispatcher.fireEvent(eventDispatchers.HIDE_STICKY_FRAMES_CONTAINER_FG);
    dispatcher.fireEvent(eventDispatchers.HIDE_MONEY_FEATURE);
  }
  /**
 * play blast anim on console panel
 */
  private playBlastAnimOnWinMeter(): void {
    const lightAnim: SpineBase = this.view.getSpineById("lightHitAnimation");
    lightAnim.visible = true;
    lightAnim.playAnim('Win_meter_blast');
    lightAnim.onComplete.addOnce(() => {
      lightAnim.visible = false;
    })
  }
  private hideReelView() {
    this.view.hide();
  }
  private showReelView() {
    this.view.show();
    this.progressMeterValues();
  }

  
    private handleOnDifferentMarket(): void {
        this.hideAutoplayButtons();
        this.hideTurboButtons();
        this.hideForceStopButton();
    }
    // Add to hide autoplay buttons using alpha
    protected hideAutoplayButtons() {
        if (!SlotConstantsBehavior.SHOW_AUTOPLAY_BUTTONS) {
            const autoPlayButton = this.view.getImageById("autoPlayOn");
            autoPlayButton && (autoPlayButton.visible = false);
            autoPlayButton && (autoPlayButton.alpha = 0);
        }
    }
    // Add to hide turbo buttons using alpha
    protected hideTurboButtons() {
        if (!SlotConstantsBehavior.SHOW_TURBO_BUTTONS) {
            const turboEnableBtn = this.view.getImageById("turboModeEnableBtnFg");
            const turboDisableBtn = this.view.getImageById("turboModeDisableBtnFg");
            turboEnableBtn && (turboEnableBtn.visible = false);
            turboEnableBtn && (turboEnableBtn.alpha = 0);
            turboDisableBtn && (turboDisableBtn.alpha = 0);
            turboDisableBtn && (turboDisableBtn.visible = false);
        }
    }
    // Add to hide force stop button using alpha
    protected hideForceStopButton() {
        if (!SlotConstantsBehavior.SHOW_FORCE_STOP_BUTTON) {
            const spinStopBtn = this.view.getButtonById(SlotConstantsBehavior.SPIN_STOP_BUTTON);
            spinStopBtn && (spinStopBtn.visible = false);
            spinStopBtn && (spinStopBtn.alpha = 0);
        }
    }
}
